// extracted by mini-css-extract-plugin
export default {"backdrop":"Loader_backdrop__xqdCA","inlineLoader":"Loader_inlineLoader__8ToBJ","spinner":"Loader_spinner__rJu3z","spin":"Loader_spin__St0FD"};